angular.module('access.Nodes')
    .controller('SignFileNotaryModalController', [
        '$modalInstance',
        '$scope',
        '$translate',
        'Esignature',
        'flashMessagesService',
        'NOTARY_APP_EVENT',
        function ($modalInstance, $scope, $translate, Esignature, flashMessagesService, NOTARY_APP_EVENT) {
            $scope.modal = $modalInstance.options;
            $scope.modal.title = $translate.instant('esignature_sign_dialog_signees_title');
            $scope.modal.close = () => $scope.$broadcast(NOTARY_APP_EVENT.CLOSE);

            $scope.onAnnotationSuccess = (annotations, form_fields, signees) => {
                if ($scope.modal.loading) {
                    return;
                }

                $scope.modal.loading = true;

                const esignatureData = {
                    node_uuid: $scope.node.uuid,
                    node_revision: $scope.node.revision,
                    signees,
                    annotations,
                    form_fields
                };

                return Esignature.save(esignatureData).$promise
                    .then((esignature) => $modalInstance.close(esignature))
                    .finally(() => $scope.modal.loading = false);
            };

            $scope.onAnnotationCancel = () => $modalInstance.dismiss();

            $scope.onAnnotationError = (error) => {
                flashMessagesService.add($translate.instant(error.message), flashMessagesService.ERROR);
                $scope.$digest();
            };
        }
    ]
    );
